/**
 * PAPPO — Loading Component
 * Spinner SVG com cores PAPPO. Variante fullscreen overlay.
 */

import styles from './Loading.module.css';

export interface LoadingProps {
  /** Tamanho do spinner em px */
  size?: number;
  /** Variante fullscreen overlay */
  fullscreen?: boolean;
  /** Texto de carregamento */
  text?: string;
  /** Classe CSS adicional */
  className?: string;
}

export function Loading({ size = 40, fullscreen = false, text, className = '' }: LoadingProps) {
  const spinner = (
    <div className={`${styles.wrapper} ${className}`} role="status" aria-label="Carregando">
      <svg
        className={styles.spinner}
        width={size}
        height={size}
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle
          className={styles.track}
          cx="22" cy="22" r="18"
          fill="none"
          strokeWidth="4"
        />
        <circle
          className={styles.arc}
          cx="22" cy="22" r="18"
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="90 150"
        />
      </svg>
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );

  if (fullscreen) {
    return <div className={styles.overlay}>{spinner}</div>;
  }

  return spinner;
}
